import React from 'react';
import styled from 'styled-components';
import * as JStorage from '../../JStorage';
import {Link} from 'gatsby';
import {Add} from '@styled-icons/ionicons-outline/Add';

export default function ListSection({
  title,
  collection,
  route,
  itemRoute,
  routeName,
  className,
  color,
  category,
  isPeople,
  isNews,
}) {
  const [records, setRecords] = React.useState([]);

  React.useEffect(() => {
    async function fetchData() {
      try {
        const resp = await JStorage.fetchDocuments(
          collection,
          {
            category,
            ...(collection === 'product' && {
              public: '首頁及清單',
              end_date: {$gte: new Date().toLocaleString('sv')},
            }),
            ...(collection === 'Article_Default' && {
              start_date: {$lte: new Date().toLocaleString('sv')},
              $or: [
                {end_date: {$gte: new Date().toLocaleString('sv')}},
                {end_date: null},
              ],
              ...(isPeople ? {public_area: true} : {doctor_area: true}),
              member_only: {$ne: true},
            }),
          },
          ['-start_date'],
          {offset: 0, limit: 5},
          null,
          {token: null},
        );
        setRecords(resp.results || []);
      } catch (e) {
        console.warn(e);
      }
    }

    fetchData();
  }, [category]);

  return (
    <ListWrapper className={className} color={color}>
      <div className="header">
        <h2
          style={{
            color: isPeople ? 'inherit' : color,
            borderBottomColor: color,
          }}>
          {title}
        </h2>
        <div style={{flex: 1}}></div>
        <Link to={route + (category ? '?cat=' + category : '')}>
          <Add size={30} color={color} />
        </Link>
      </div>

      <div style={{alignSelf: 'stretch'}}>
        <ul className="records">
          {records.map((it, idx) => {
            let _itemRoute = itemRoute || route;

            return (
              <li key={idx}>
                <Link
                  to={`${_itemRoute}?id=${it.id}${
                    category ? '&cat=' + category : ''
                  }${routeName ? '&routeName=' + routeName : ''}`}>
                  <div style={{display: 'flex', alignItems: 'center'}}>
                    <div className={'date' + (isNews ? '' : ' color')}>
                      {new Date(it.start_date).toLocaleDateString('sv')}{' '}
                      {it.end_date &&
                        ' - ' + new Date(it.end_date).toLocaleDateString('sv')}
                    </div>
                    {it.category && isNews && (
                      <div style={{marginLeft: 10, color}}>{it.category}</div>
                    )}
                  </div>
                  <div className="title">{it.title || it.name}</div>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </ListWrapper>
  );
}

const ListWrapper = styled.section`
  padding: 20px;
  border-radius: 6px;
  background-color: #fff;

  .header {
    display: flex;
    align-items: center;

    & > h2 {
      border-bottom-width: 2px;
      border-bottom-style: solid;
      padding-bottom: 5px;
    }
  }

  ul.records {
    list-style: none;
    padding: 0;
    & > li {
      padding-top: 10px;
      margin-top: 10px;

      & + li {
        border-top: solid 1px rgba(0, 0, 0, 0.1);
      }
      & > a {
        color: #000;
      }
      & .date.color {
        color: ${(props) => props.color};
      }
    }

    & > li:hover {
      opacity: 0.75;
    }
  }
`;
